export type InitialClientContractDraft = {
  contractName: string;
  contractNumber: string;
  status: "draft" | "active" | "inactive" | "expired" | "cancelled";
  startsAt: string;
  endsAt: string;
  signedAt: string;
  notes: string;
  serviceIds: number[];
};

export const EMPTY_INITIAL_CLIENT_CONTRACT: InitialClientContractDraft = {
  contractName: "",
  contractNumber: "",
  status: "active",
  startsAt: "",
  endsAt: "",
  signedAt: "",
  notes: "",
  serviceIds: [],
};

export function validateInitialClientContract(draft: InitialClientContractDraft): Record<string, string> {
  const errors: Record<string, string> = {};

  if (!draft.contractName.trim()) {
    errors.contractName = "Nome do contrato é obrigatório.";
  }

  if (!draft.contractNumber.trim()) {
    errors.contractNumber = "Número do contrato é obrigatório.";
  }

  if (!draft.status) {
    errors.status = "Status é obrigatório.";
  }

  if (!draft.signedAt) {
    errors.signedAt = "A data de assinatura é obrigatória.";
  }

  if (!draft.startsAt) {
    errors.startsAt = "A data de início da vigência é obrigatória.";
  }

  if (!draft.endsAt) {
    errors.endsAt = "A data de fim da vigência é obrigatória.";
  }

  if (draft.startsAt && draft.endsAt && draft.endsAt < draft.startsAt) {
    errors.endsAt = "A data de fim da vigência deve ser igual ou posterior ao início da vigência.";
  }

  if (draft.serviceIds.length === 0) {
    errors.serviceIds = "Selecione pelo menos um serviço para compor o contrato inicial.";
  }

  return errors;
}

export function isInitialClientContractComplete(draft: InitialClientContractDraft): boolean {
  return Object.keys(validateInitialClientContract(draft)).length === 0;
}

export function normalizeInitialContractServiceIds(
  selectedIds: number[],
  allowedIds: number[],
): number[] {
  const allowedSet = new Set(allowedIds);
  return Array.from(new Set(selectedIds.filter((id) => allowedSet.has(id))));
}

export function toggleInitialContractService(
  selectedIds: number[],
  serviceId: number,
  checked: boolean,
): number[] {
  if (checked) {
    return Array.from(new Set([...selectedIds, serviceId]));
  }

  return selectedIds.filter((id) => id !== serviceId);
}
